import React from 'react'
import {connect} from 'react-redux'

import {
  ROLES
} from './config/constants'

const {ADMIN, EXPERT} = ROLES

import closeModal from './data/actions/close_modal'
import showModal from './data/actions/show_modal'

import ModalView from './modal_view'
import ProfileImage from './profile_image'
import RoleIndicator from './role_indicator'
import ExpertRating from './expert_rating'
import ExpertSessionsCount from './expert_sessions_count'

class UserProfileModal extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isActive: true
    }

    this.onClose = this.onClose.bind(this)
    this.onReportClick = this.onReportClick.bind(this)
  }

  onClose (e) {
    if (e) e.stopPropagation()

    this.setState({
      isActive: false
    })

    this.props.closeModal(this.props.modalKey)
  }

  onReportClick (e) {
    if (e && e.preventDefault) e.preventDefault()

    this.props.showModal({type: 'report', props: {reportee: this.props.user}})
  }

  renderDetailRow (label, content) {
    return (
      <div style={{display: 'table-row'}}>
        <div style={{display: 'table-cell', textAlign: 'right', fontWeight: 'bold', width: '30%'}}>
          {label}
        </div>
        <div style={{display: 'table-cell', textAlign: 'left', width: '70%'}}>
          {content}
        </div>
      </div>
    )
  }

  renderExpertDetails () {
    if (this.props.user.get('role') === EXPERT) {
      const content = []

      content.push(this.renderDetailRow('Rating:', <ExpertRating rating={this.props.user.get('rating')} />));
      content.push(this.renderDetailRow('Sessions:', <ExpertSessionsCount uid={this.props.user.get('uid')} />));

      if (this.props.user.get('specialty')) {
        content.push(this.renderDetailRow('Specialty:', this.props.user.get('specialty')))
      }

      return content
    }
  }

  renderUserDetails () {
    const RoleDetails = <RoleIndicator role={this.props.user.get('role')} size={14}/>

    return (
      this.renderDetailRow('Role:', RoleDetails)
    )
  }

  renderDetails () {
    return (
      <div style={{display: 'table', margin: 'auto', borderSpacing: 10, fontSize: 16}}>
        {this.renderUserDetails()}
        {this.renderExpertDetails()}
      </div>
    )
  }

  renderReportButton () {
    if (this.props.user && this.props.user.get('role') === ADMIN) return false

    return (
      <div className='button danger stripped' onClick={this.onReportClick}>Report User</div>
    )
  }

  renderModalContent () {
    if (this.props.user) {
      return (
        <div>
          <div className='modal-header' style={{textAlign: 'center'}}>
            <div style={{margin: '0 auto'}}>
              <div style={{display: 'inline-block', marginRight: 5}}>
                <ProfileImage user={this.props.user.toJS()} image={this.props.user.get('profileImage')}/>
              </div>
              <h4 style={{display: 'inline-block'}}>{this.props.user.get('name')}</h4>
            </div>
          </div>
          <div className='modal-body' style={{paddingTop: 10}}>
            {this.renderDetails()}
          </div>
          <div className='modal-footer'>
            <div className='actions right'>
              {this.renderReportButton()}
              <div className='cancel button default' onClick={this.onClose}>Cancel</div>
            </div>
          </div>
        </div>
      )
    }
  }

  render () {
    return (
      <ModalView isActive={this.state.isActive} onClose={this.onClose}>
        {this.renderModalContent()}
      </ModalView>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.getIn(['users', ownProps.uid])
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: (modalKey) => dispatch(closeModal(modalKey)),
    showModal: (modal) => dispatch(showModal(modal))
  }
}

const UserProfileModalContainer = connect(
  mapStateToProps, mapDispatchToProps
)(UserProfileModal)

export default UserProfileModalContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/user_profile_modal.js
 **/